module.exports = __webpack_public_path__ + "static/media/picture-quiz-character-sound_x3.a83f25ca.mp3";